import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowRightFill } from '@lyearn/icons';
import { Stack, Typography } from '@lyearn/ui';

interface AnswerMapProps {
  labelLeft: string | React.ReactNode;
  labelRight?: string | React.ReactNode;
}

const AnswerMap: React.FC<AnswerMapProps> = ({ labelLeft, labelRight }) => {
  const { t } = useTranslation();

  const isAnswered = Boolean(labelRight);

  return (
    <Stack className="w-full flex-wrap" gapX={4}>
      <Typography color="text-text-paragraph" variant="body-short-02">
        {labelLeft}
      </Typography>
      <ArrowRightFill
        className="w-16 h-16 flex-shrink-0 mt-[0.3rem]"
        fillColorToken="icon-placeholder"
      />
      {isAnswered ? (
        <Typography color="text-text-paragraph" variant="body-short-02">
          {labelRight}
        </Typography>
      ) : (
        <Typography color="text-text-placeholder" variant="label-02">
          {t('QuizPlayer:NotAnswered')}
        </Typography>
      )}
    </Stack>
  );
};

export default AnswerMap;
